import React, { useEffect, useRef, useState } from 'react';
import { Check, ChevronRight, Monitor, Moon, Palette, Sun } from 'lucide-react';
import { THEME_PREF, normalizeBlacktheme } from './themePreference';
import './UserAppearanceMenu.css';

const CLOSE_DELAY_MS = 160;

const OPTIONS = [
  {
    value: THEME_PREF.LIGHT,
    label: 'Claro',
    Icon: Sun,
  },
  {
    value: THEME_PREF.DARK,
    label: 'Escuro',
    Icon: Moon,
  },
  {
    value: THEME_PREF.SYSTEM,
    label: 'Sistema',
    Icon: Monitor,
  },
];

/**
 * Item "Aparência" do menu do usuário — submenu ao hover/focus.
 */
export function UserAppearanceMenuItem({ preference, onSelect, disabled }) {
  const [open, setOpen] = useState(false);
  const closeTimerRef = useRef(null);
  const current = normalizeBlacktheme(preference);

  const clearCloseTimer = () => {
    if (closeTimerRef.current != null) {
      window.clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
  };

  const openMenu = () => {
    clearCloseTimer();
    setOpen(true);
  };

  const scheduleClose = () => {
    clearCloseTimer();
    closeTimerRef.current = window.setTimeout(() => {
      setOpen(false);
      closeTimerRef.current = null;
    }, CLOSE_DELAY_MS);
  };

  useEffect(() => () => clearCloseTimer(), []);

  return (
    <div
      className={`logout-menu-appearance${open ? ' is-open' : ''}`}
      onMouseEnter={openMenu}
      onMouseLeave={scheduleClose}
      onFocus={openMenu}
      onBlur={(e) => {
        if (!e.currentTarget.contains(e.relatedTarget)) scheduleClose();
      }}
    >
      <button
        type="button"
        className="ec-actions-menu-item logout-menu-appearance-trigger"
        role="menuitem"
        aria-haspopup="menu"
        aria-expanded={open}
        disabled={disabled}
      >
        <Palette size={16} strokeWidth={1.5} aria-hidden />
        <span className="logout-menu-appearance-label">Aparência</span>
        <ChevronRight size={14} strokeWidth={1.75} className="logout-menu-appearance-chevron" aria-hidden />
      </button>

      {open ? (
        <div className="logout-menu-appearance-submenu" role="menu" aria-label="Aparência">
          {OPTIONS.map(({ value, label, Icon }) => {
            const selected = current === value;
            return (
              <button
                key={value}
                type="button"
                className={`ec-actions-menu-item logout-menu-appearance-option${selected ? ' is-selected' : ''}`}
                role="menuitemradio"
                aria-checked={selected}
                disabled={disabled}
                onClick={(e) => {
                  e.stopPropagation();
                  onSelect(value, e);
                }}
              >
                <Icon size={16} strokeWidth={1.5} aria-hidden />
                <span className="logout-menu-appearance-option-label">{label}</span>
                {selected ? <Check size={14} strokeWidth={2} className="logout-menu-appearance-check" aria-hidden /> : null}
              </button>
            );
          })}
        </div>
      ) : null}
    </div>
  );
}
